import React, { createContext, useState, useContext } from 'react';

const PageTitleContext = createContext({
    pageTitle: '',
    setPageTitle: () => {},
    rightContent: null,
    setRightContent: () => {},
    backIcon: false,
    setBackIcon: () => {},
});

export const PageTitleProvider = ({ children }) => {
    const [pageTitle, setPageTitle] = useState('');
    const [rightContent, setRightContent] = useState(null);
    const [backIcon, setBackIcon] = useState(false);

    return (
        <PageTitleContext.Provider value={{ pageTitle, setPageTitle, rightContent, setRightContent, backIcon, setBackIcon }}>
            {children}
        </PageTitleContext.Provider>
    );
};

export const usePageTitle = () => useContext(PageTitleContext);

export default PageTitleContext;